export default __webpack_public_path__ + "static/media/_dkg_harnblasenkrebs_rgb.ab1e52bd.svg";